import { render, staticRenderFns } from "./WorkStatusOnboarding.vue?vue&type=template&id=282e98ba"
import script from "./WorkStatusOnboarding.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkStatusOnboarding.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports